import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 1,
      name: i18n.t('wizard.package.pack_1'),
    },
    {
      id: 2,
      name: i18n.t('wizard.package.pack_2'),
    },
    {
      id: 3,
      name: i18n.t('wizard.package.pack_3'),
    },
    {
      id: 4,
      name: i18n.t('wizard.package.pack_4'),
    },
    {
      id: 5,
      name: i18n.t('wizard.package.pack_5'),
    },
    {
      id: 6,
      name: i18n.t('wizard.package.pack_6'),
    },
  ]
}

export function TIPOS_PAQUETES_CONTRATACION (state) {
  return configHelper.getConfig(state, 'TIPOS_PAQUETES_CONTRATACION', GenerateConfig)
}

